<template>
  <div class="recherche-list">
    <h2>Address Search</h2>
    <p><small><strong>Version 2.1</strong>: Complete address list. Data synchronization between database and search is currently every midnight.</small></p>
    <b-alert v-model="hasError" variant="danger">
      {{ errorMessage }}
    </b-alert>
    <b-overlay :show="showOverlay" rounded="sm" z-index="2000" variant="white" :opacity="0.90">
      <div class="sidebar-container">
        <div class="filter-container">
          <div class="toggle-menu">
            <i @click="toggleSidebar" v-if="!isActive" class="fas fa-2x fa-angle-double-right"></i>
            <i @click="toggleSidebar" v-if="isActive" class="fas fa-2x fa-angle-double-left"></i>
          </div>
          <div class="filter-sidebar" v-bind:class="{ active: isActive }">
            <filter-bar @send-custom-filters="sendFilters" ref="filterbarComponent"/>
          </div>
        </div>
        <div class="search-container">
          <dx-data-grid
            :data-source="dataSource"
            :ref="dataGridRecherche2"
            :remote-operations="true"
            id="gridContainerMeilisearch"
            class="meilisearch-datagrid"
            :show-borders="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :column-min-width="50"
            columnResizingMode="widget"
            :showColumnLines="true"
            :showRowLines="true"
            :no-data-text="$t('general.noEntries')"
            :column-auto-width="false"
            :word-wrap-enabled="true"
            :hover-state-enabled="true"
            @contentReady="contentReady"
            :sync-lookup-filter-values="false"
          >
            <dx-scrolling
              mode="virtual"
              row-rendering-mode="virtual"
            />
            <dx-paging :page-size="pageSize"/>
            <!--<dx-selection
            select-all-mode="page"
            show-check-boxes-mode="always"
            :allowSelectAll="true"
            mode="multiple"
          />-->
            <dx-filter-panel :visible="false"/>
            <dx-filter-row
              :visible="true"
              apply-filter=""
            />
            <dx-header-filter
              :visible="false"
            />
            <dx-column-chooser
              :enabled="false"
              mode="select"
            >
              <dx-column-chooser-search
                :enabled="true"
              />
            </dx-column-chooser>
            <dx-column
              :caption="$t('recherche.search.id')"
              data-field="id"
              data-type="number"
              :width="60"
              cell-template="link-to-crm-template"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
            />
            <dx-column
              caption="Datum"
              data-field="datum"
              :width="100"
              :visible="false"
              data-type="date"
              format="dd.MM.yyyy"
              :allow-filtering="false"
            />
            <dx-column
              :caption="$t('recherche.detail.company')"
              data-field="_formatted.company"
              :calculate-cell-value="tempDevCompany"
              :width="150"
              :filter-operations="allowedOperationsString"
              :editor-options="{ showClearButton: true }"
              :encodeHtml="false"
            />
            <dx-column
              :caption="$t('recherche.detail.firstname')"
              data-field="_formatted.firstName"
              :filter-operations="allowedOperationsString"
              :editor-options="{ showClearButton: true }"
              :width="120"
              :encodeHtml="false"
            />
            <dx-column
              :caption="$t('recherche.detail.lastname')"
              data-field="_formatted.lastName"
              :filter-operations="allowedOperationsString"
              :editor-options="{ showClearButton: true }"
              :width="120"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.crmProfiles[0].oneLiner_en)"
              :caption="$t('recherche.detail.oneLinerEn')"
              :calculate-cell-value="calculateOneLiner"
              :width="200"
              :allow-sorting="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              :caption="$t('recherche.detail.descriptionEN')"
              data-field="_formatted.crmProfiles[0].description_open_en"
              :calculate-cell-value="calculateDescription"
              :width="400"
              :allow-sorting="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.streetB"
              :caption="$t('recherche.detail.streetB')"
              :filter-operations="allowedOperationsString"
              :editor-options="{ showClearButton: true }"
              :width="150"
              :visible="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.zipB"
              :caption="$t('recherche.detail.zipB')"
              :visible="false"
              :width="100"
              :filter-operations="allowedOperationsString"
              :editor-options="{ showClearButton: true }"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.cityB"
              :caption="$t('recherche.detail.cityB')"
              :width="120"
              :filter-operations="allowedOperationsString"
              :editor-options="{ showClearButton: true }"
              :encodeHtml="false"
            />
            <dx-column
              :caption="$t('recherche.detail.countryB')"
              data-field="countryBId"
              cell-template="countryBTemplate"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
              :width="150"
            >
              <dx-lookup
                :data-source="countryTypes"
                display-expr="land"
                value-expr="field_001"
              />
            </dx-column>
            <dx-column
              data-field="incorporationDate"
              :caption="$t('recherche.detail.incorporationDate')"
              :width="100"
              data-type="date"
              format="dd.MM.yyyy"
              :allow-filtering="false"
            />
            <dx-column
              data-field="universityId"
              :caption="$t('recherche.detail.university')"
              cell-template="universityTemplate"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
              :width="150"
            >
              <dx-lookup
                :data-source="universityTypes"
                display-expr="university"
                value-expr="field_001"
              />
            </dx-column>
            <dx-column
              data-field="universityFacultyIDId"
              :caption="$t('recherche.detail.faculty')"
              cell-template="facultyTemplate"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
              :width="150"
            >
              <dx-lookup
                :data-source='facultyUniversityTypes'
                display-expr='departementFaculty'
                value-expr='field_001'
              />
            </dx-column>
            <dx-column
              data-field="_formatted.mobileB"
              :caption="$t('recherche.detail.mobile')"
              :visible="false"
              :width="150"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.phoneB"
              :caption="$t('recherche.detail.phoneB')"
              :visible="false"
              :width="150"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.emailB1"
              :caption="$t('recherche.detail.email')"
              :width="200"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.emailB2"
              :caption="$t('recherche.detail.emailB2')"
              :width="200"
              :visible="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.facebookB"
              :caption="$t('recherche.detail.facebookB')"
              :width="150"
              :visible="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.linkedInB"
              :caption="$t('recherche.detail.linkedInB')"
              :width="150"
              :visible="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.twitterB"
              :caption="$t('recherche.detail.twitterB')"
              :width="150"
              :visible="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.instagramB"
              :caption="$t('recherche.detail.instagramB')"
              :width="150"
              :visible="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.similarwebB"
              :caption="$t('recherche.detail.similarwebB')"
              :width="150"
              :visible="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.alexaB"
              :caption="$t('recherche.detail.alexaB')"
              :width="150"
              :visible="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.permalink"
              :caption="$t('recherche.detail.permalink')"
              :width="150"
              :visible="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="salutationId"
              :caption="$t('recherche.detail.salutationId')"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
              :width="120"
            >
              <dx-lookup
                :data-source='salutationTypes'
                :display-expr='getDisplayExpr'
                value-expr='ansprechzeile_id'
              />
            </dx-column>
            <dx-column
              data-field="_formatted.internetB"
              :caption="$t('recherche.detail.internet')"
              :width="150"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="startupPhaseId"
              :caption="$t('recherche.detail.startupPhase')"
              cell-template="startupPhaseTemplate"
              :width="120"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
            >
              <dx-lookup
                :data-source="startupPhaseTypes"
                display-expr="startupphase"
                value-expr="field_001"
              />
            </dx-column>
            <dx-column
              v-if="checkAdmin(currentUser.mitarbeiterId)"
              data-field="totalFundings"
              :caption="$t('recherche.detail.totalFunding')"
              :format="totalFormat"
              :allow-filtering="false"
              :allow-sorting="true"
              :width="120"
            />
            <dx-column
              data-field="technologyId"
              :caption="$t('recherche.detail.technology')"
              cell-template="technologyTemplate"
              :width="150"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
            >
              <dx-lookup
                :data-source="brancheTypes"
                display-expr="brancheEn"
                value-expr="field_001"
                :allow-clearing="true"
              />
            </dx-column>
            <dx-column
              :caption="$t('recherche.detail.sectors')"
              data-field="sectors"
              :calculate-cell-value="calculateSectors"
              :width="400"
              :allow-sorting="false"
              :allow-filtering="false"
              :visible="false"
            />
            <dx-column
              :caption="$t('recherche.detail.awards')"
              data-field="contests"
              :calculate-cell-value="calculateAwards"
              :width="300"
              :allow-sorting="false"
              :allow-filtering="false"
              :visible="false"
            />
            <dx-column
              :caption="$t('recherche.detail.events')"
              data-field="eventlistTitleEN"
              cell-template="eventsTemplate"
              :width="400"
              :allow-sorting="false"
              :allow-filtering="false"
              :visible="false"
            />
            <dx-column
              :caption="$t('recherche.detail.roles')"
              data-field="roles"
              :calculate-cell-value="calculateRoles"
              :width="300"
              :allow-sorting="false"
              :allow-filtering="false"
              :visible="false"
            />
            <dx-column
              data-field="unispinoffId"
              :caption="$t('recherche.detail.unispinoff')"
              cell-template="uniSpinOffTemplate"
              :visible="false"
              :width="150"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
            >
              <dx-lookup
                :data-source="universityTypes"
                display-expr="university"
                value-expr="field_001"
              />
            </dx-column>
            <dx-column
              data-field="priovlabId"
              :caption="$t('recherche.detail.priovlabId')"
              cell-template="prioVlabTemplate"
              :visible="false"
              :width="100"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
            >
              <dx-lookup
                :data-source="priovlabTypes"
                display-expr="status"
                value-expr="field_001"
              />
            </dx-column>
            <dx-column
              data-field="prioXMasId"
              :caption="$t('recherche.detail.prioXMasId')"
              cell-template="prioXmasTemplate"
              :visible="false"
              :width="100"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"

            >
              <dx-lookup
                :data-source="priovlabxmasTypes"
                display-expr="statusxmas"
                value-expr="field_001"
              />
            </dx-column>
            <dx-column
              data-field="vkCaseStatus"
              :caption="$t('recherche.detail.vKCaseStatus')"
              cell-template="vkCaseStatusTemplate"
              :visible="false"
              :width="120"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
            >
              <dx-lookup
                :data-source="vkCaseStatusTypes"
                display-expr="casestatus"
                value-expr="field_001"
              />
            </dx-column>
            <dx-column
              data-field="vKacademiclinkId"
              :caption="$t('recherche.detail.vKacademiclink')"
              cell-template="vkAcademicLinkTemplate"
              :visible="false"
              :width="150"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
            >
              <dx-lookup
                :data-source="universityTypes"
                display-expr="university"
                value-expr="field_001"
              />
            </dx-column>
            <dx-column
              data-field="_formatted.tradeRegisterNr"
              :caption="$t('recherche.detail.tradeRegisterNr')"
              :width="120"
              :visible="false"
              :filter-operations="allowedOperationsString"
              :editor-options="{ showClearButton: true }"
              :encodeHtml="false"
            />
            <dx-column
              data-field="legalFormId"
              :caption="$t('recherche.detail.legalFormId')"
              cell-template="legalFormTemplate"
              :visible="false"
              :width="120"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
            >
              <dx-lookup
                :data-source='rechtsformTypes'
                display-expr='rechtsform'
                value-expr='field_001'
              />
            </dx-column>
            <dx-column
              data-field="_formatted.streetP"
              :caption="$t('recherche.detail.streetP')"
              :width="150"
              :visible="false"
              :filter-operations="allowedOperationsString"
              :editor-options="{ showClearButton: true }"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.zipP"
              :caption="$t('recherche.detail.zipP')"
              :width="100"
              :visible="false"
              :filter-operations="allowedOperationsString"
              :editor-options="{ showClearButton: true }"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.cityP"
              :caption="$t('recherche.detail.cityP')"
              :width="120"
              :visible="false"
              :filter-operations="allowedOperationsString"
              :editor-options="{ showClearButton: true }"
              :encodeHtml="false"
            />
            <dx-column
              :caption="$t('recherche.detail.countryP')"
              data-field="countryPId"
              cell-template="countryPTemplate"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
              :width="150"
              :visible="false"
            >
              <dx-lookup
                :data-source="countryTypes"
                display-expr="land"
                value-expr="field_001"
              />
            </dx-column>
            <dx-column
              data-field="_formatted.mobileP"
              :caption="$t('recherche.detail.mobileP')"
              :visible="false"
              :width="150"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.phoneP"
              :caption="$t('recherche.detail.phoneP')"
              :visible="false"
              :width="150"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.emailP1"
              :caption="$t('recherche.detail.emailP1')"
              :width="200"
              :visible="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.emailP2"
              :caption="$t('recherche.detail.emailP2')"
              :width="200"
              :visible="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.facebookP"
              :caption="$t('recherche.detail.facebookP')"
              :width="150"
              :visible="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.linkedInP"
              :caption="$t('recherche.detail.linkedInP')"
              :width="150"
              :visible="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="_formatted.twitterP"
              :caption="$t('recherche.detail.twitterP')"
              :width="150"
              :visible="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              data-field="birthday"
              :caption="$t('recherche.detail.birthday')"
              :width="100"
              data-type="date"
              format="dd.MM.yyyy"
              :visible="false"
              :allow-filtering="false"
            />
            <dx-column
              data-field="languageId"
              :caption="$t('recherche.detail.languageId')"
              cell-template="languageTemplate"
              :visible="false"
              :width="100"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
            >
              <dx-lookup
                :data-source="languagesTypes"
                display-expr="spracheEN"
                value-expr="field_001"
              />
            </dx-column>
            <dx-column
              data-field="educationId"
              :caption="$t('recherche.detail.educationId')"
              cell-template="educationTemplate"
              :visible="false"
              :width="120"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
            >
              <dx-lookup
                :data-source="educationTypes"
                display-expr="education"
                value-expr="field_001"
              />
            </dx-column>
            <dx-column
              data-field="_formatted.position"
              :caption="$t('recherche.detail.position')"
              :visible="false"
              :width="150"
              :filter-operations="allowedOperationsString"
              :editor-options="{ showClearButton: true }"
              :encodeHtml="false"
            />
            <dx-column
              data-field="kantonId"
              :caption="$t('recherche.detail.kantonId')"
              cell-template="cantonTemplate"
              :visible="false"
              :width="120"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
            >
              <dx-lookup
                :data-source="cantonTypes"
                display-expr="kantonEN"
                value-expr="field_001"
              />
            </dx-column>
            <dx-column
              v-if="checkAdmin(currentUser.mitarbeiterId)"
              data-field="crmProfiles.peopleFemaleFounders"
              :caption="$t('recherche.detail.peoplefemalefounders')"
              :calculate-cell-value="calculateFemaleFounders"
              :visible="false"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
              :width="120"
            />
            <dx-column
              v-if="checkAdmin(currentUser.mitarbeiterId)"
              data-field="crmProfiles.peopleMaleFounders"
              :caption="$t('recherche.detail.peoplemalefounders')"
              :calculate-cell-value="calculateMaleFounders"
              :visible="false"
              :filter-operations="allowedOperations"
              :editor-options="{ showClearButton: true }"
              :width="120"
            />
            <dx-column
              v-if="checkAdmin(currentUser.mitarbeiterId)"
              data-field="crmProfiles[0].totalEmployee"
              :caption="$t('recherche.detail.totalEmployee')"
              :calculate-cell-value="calculateEmployees"
              :allow-sorting="false"
              :allow-filtering="false"
              :visible="false"
              :width="80"
            />
            <dx-column
              :caption="$t('recherche.search.vleadersproblemopportunity')"
              data-field="_formatted.crmProfiles[0].vleadersproblemopportunity"
              :calculate-cell-value="calculateOpportunity"
              :width="350"
              :visible="false"
              :allow-sorting="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              :caption="$t('recherche.search.vleadersProductservice')"
              data-field="_formatted.crmProfiles[0].vleadersProductservice"
              :calculate-cell-value="calculateProductservice"
              :width="350"
              :visible="false"
              :allow-sorting="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              caption="Vleaders Technology"
              data-field="_formatted.crmProfiles[0].vleadersTechnologie"
              :calculate-cell-value="calculateTechnology"
              :width="350"
              :visible="false"
              :allow-sorting="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              caption="Vleaders Target Customers"
              data-field="_formatted.crmProfiles[0].vleadersTargetcustomers"
              :calculate-cell-value="calculateTargetcustomers"
              :width="350"
              :visible="false"
              :allow-sorting="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              caption="Vleaders Market Competition"
              data-field="_formatted.crmProfiles[0].vleadersMarketcompetition"
              :calculate-cell-value="calculateMarketCompetition"
              :width="350"
              :visible="false"
              :allow-sorting="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              caption="Vleaders Team"
              data-field="_formatted.crmProfiles[0].vleadersTeam"
              :calculate-cell-value="calculateVleadersTeam"
              :width="350"
              :visible="false"
              :allow-sorting="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              caption="Vleaders Achievements"
              data-field="_formatted.crmProfiles[0].vLeadersAchievements"
              :calculate-cell-value="calculateAchievements"
              :width="350"
              :visible="false"
              :allow-sorting="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              caption="Vleaders Financials"
              data-field="_formatted.crmProfiles[0].vleadersFinancials"
              :calculate-cell-value="calculateFinancials"
              :width="350"
              :visible="false"
              :allow-sorting="false"
              :allow-filtering="false"
              :encodeHtml="false"
            />
            <dx-column
              :caption="$t('recherche.search.matchingColumns')"
              :calculate-cell-value="getMatchingColumns"
              :width="300"
              :allow-sorting="false"
              :allow-filtering="false"
            />
            <template #link-to-crm-template="{ data }">
              <a v-if="data.data.id && data.data.crmProfiles.length" :href="data.data.crmProfiles.find( el => el.profiltypId === 2 ) ? `https://crm.ifj.ch/index.cfm?&page=137659&crm_adresse_id=${data.data.id}`: `https://crm.ifj.ch/index.cfm?&page=137767&crm_adresse_id=${data.data.id}`" target="_blank">{{data.data.id}}</a>
              <a v-else :href="`https://crm.ifj.ch/index.cfm?&page=117525&ADDRESSESID=${data.data.id}`" target="_blank">{{data.data.id}}</a>
            </template>
            <template #cantonTemplate="{ data }">
              <div v-if="data.data.crmCanton.length"><span v-html="data.data._formatted.crmCanton[0].kantonEN"></span></div>
            </template>
            <template #educationTemplate="{ data }">
              <div v-if="data.data.crmEducations.length"><span v-html="data.data._formatted.crmEducations[0].education"></span></div>
            </template>
            <template #languageTemplate="{ data }">
              <div v-if="data.data.crmLanguages.length"><span v-html="data.data._formatted.crmLanguages[0].languageEn"></span></div>
            </template>
            <template #countryPTemplate="{ data }">
              <div v-if="data.data.crmCountriesP.length"><span v-html="data.data._formatted.crmCountriesP[0].land"></span></div>
            </template>
            <template #legalFormTemplate="{ data }">
              <div v-if="data.data.crmRechtsformen.length"><span v-html="data.data._formatted.crmRechtsformen[0].rechtsform"></span></div>
            </template>
            <template #vkAcademicLinkTemplate="{ data }">
              <div v-if="data.data.crmAcademicLink.length"><span v-html="data.data._formatted.crmAcademicLink[0].university"></span></div>
            </template>
            <template #vkCaseStatusTemplate="{ data }">
              <div v-if="data.data.crmCaseStatus.length"><span v-html="data.data._formatted.crmCaseStatus[0].casestatus"></span></div>
            </template>
            <template #prioXmasTemplate="{ data }">
              <div v-if="data.data.crmPrioXMas.length"><span v-html="data.data._formatted.crmPrioXMas[0].statusXmas"></span></div>
            </template>
            <template #prioVlabTemplate="{ data }">
              <div v-if="data.data.crmPrioVlab.length"><span v-html="data.data._formatted.crmPrioVlab[0].status"></span></div>
            </template>
            <template #uniSpinOffTemplate="{ data }">
              <div v-if="data.data.crmUniSpinOff.length"><span v-html="data.data._formatted.crmUniSpinOff[0].university"></span></div>
            </template>
            <template #technologyTemplate="{ data }">
              <div v-if="data.data.crmBranchen.length"><span v-html="data.data._formatted.crmBranchen[0].brancheEn"></span></div>
            </template>
            <template #startupPhaseTemplate="{ data }">
              <div v-if="data.data.crmStartupphases.length"><span v-html="data.data._formatted.crmStartupphases[0].startupphase"></span></div>
            </template>
            <template #facultyTemplate="{ data }">
              <div v-if="data.data.crmUniversityFaculty.length"><span v-html="data.data._formatted.crmUniversityFaculty[0].departementFaculty"></span></div>
            </template>
            <template #universityTemplate="{ data }">
              <div v-if="data.data.crmUniversityFaculty.length"><span v-html="data.data._formatted.crmUniversityFaculty[0].university"></span></div>
            </template>
            <template #countryBTemplate="{ data }">
              <div v-if="data.data.crmCountriesB.length"><span v-html="data.data._formatted.crmCountriesB[0].land"></span></div>
            </template>
            <template #eventsTemplate="{ data }">
              <div v-if="data.data.eventlistTitleEN.length">
                <span
                  v-for="(event, index) in data.data.eventlistTitleEN"
                  :key="index"
                >
                  <span>{{event}}, </span>
                </span>
              </div>
            </template>
            <dx-master-detail
              :enabled="true"
              template="masterDetailTemplate"
            />
            <template #masterDetailTemplate="{ data }">
              <detail-template
                :masterDetailData="data"
              />
            </template>
            <dx-toolbar>
              <dx-item
                location="before"
                template="totalGroupCount"
              />
              <dx-item
                location="after"
                template="customizedInfoModal"
              />
              <dx-item
                location="after"
                template="customizedSearchbar"
              />
              <dx-item
                location="after"
                template="customizedToolbar"
              />
              <dx-item
                location="after"
                template="actionmenu"
              />
            </dx-toolbar>
            <template #totalGroupCount>
              <span v-if="initTotalCount !== 0">{{ totalDevExpress }} results out of {{ initTotalCount }} records</span>
            </template>
            <template #customizedInfoModal>
              <div>
                <i class="fas fa-question-circle fa-lg" @click="modalShow = !modalShow"></i>
                <b-modal v-model="modalShow" centered id="modal-info" ok-only title="Fulltextsearch" button-size="sm" okTitle='Close'>
                  <info-modal/>
                </b-modal>
              </div>
            </template>
            <template #customizedSearchbar>
              <dx-text-box
                :show-clear-button="true"
                v-model="searchParam"
                :on-value-changed="search"
                placeholder="Fulltextsearch..."
                value-change-event="input"
                class="searchbar"
              />
            </template>
            <template #actionmenu>
              <div>
                <v-menu
                  offset-y
                  bottom
                  left
                  content-class="toolbar-action-menu"
                >
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      color="secondary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <i class="fas fa-cog"></i> Actions
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                      link
                      @click="openColumnChooser"
                    >
                      <v-list-item-title><i class="fas fa-columns mr-1"></i> Column Chooser</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      link
                      @click="onExporting"
                      :disabled="!enableExport"
                    >
                      <v-list-item-title><i class="fas fa-file-excel mr-2"></i> Excel Export</v-list-item-title>
                    </v-list-item>
                    <v-tooltip left max-width="400" open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-list-item
                          link
                          @click="saveQuery"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-list-item-title><i class="fas fa-save mr-2"></i> Save Query</v-list-item-title>
                        </v-list-item>
                      </template>
                      <span>Save a query for future / recuring use with predefined filters you are currently using in the query:<br>
                        Use the naming guidelines to save the query</span>
                    </v-tooltip>
                    <v-tooltip left max-width="400" open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-list-item
                          link
                          @click="loadQuery"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-list-item-title><i class="fas fa-download mr-2"></i> Load Query</v-list-item-title>
                        </v-list-item>
                      </template>
                      <span>Open a saved query</span>
                    </v-tooltip>
                    <v-tooltip left max-width="400" open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-list-item
                          link
                          @click="saveState"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-list-item-title><i class="fas fa-save mr-2"></i> Save Template</v-list-item-title>
                        </v-list-item>
                      </template>
                      <span>Save the columns template</span>
                    </v-tooltip>
                    <v-tooltip left max-width="400" open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-list-item
                          link
                          @click="loadState"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-list-item-title><i class="fas fa-download mr-2"></i> Load Template</v-list-item-title>
                        </v-list-item>
                      </template>
                      <span>Open a columns template</span>
                    </v-tooltip>
                  </v-list>
                </v-menu>
              </div>
            </template>
            <template #customizedToolbar>
              <div>
                <v-tooltip left max-width="400" open-delay="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      @click="addToPool"
                      :disabled="activateSaveList"
                      v-bind="attrs"
                      v-on="on"
                    >Add to Pool</v-btn>
                  </template>
                  <span>Add the address Search list into the Pool list:<br>A pool is a locally stored tempary list, which you can modify
                    (add or remove records) before saving it as "Saved list",
                    which can be used for mailings.<br>
                    The addition may take a moment depending on the amount of data.</span>
                </v-tooltip>
                <v-tooltip top max-width="400" open-delay="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      outlined
                      class="btn-pdl"
                      @click="goToPool"
                      v-bind="attrs"
                      v-on="on"
                    >Go to Pool</v-btn>
                  </template>
                  <span>Open the Pool list for modification</span>
                </v-tooltip>
              </div>
            </template>
          </dx-data-grid>
          <save-template :template="template"/>
          <load-template :tableType="tableType" @set-state-5="loadSelectedTemplate" @set-default-state-5="loadDefaultTemplate"/>
          <save-search-query :searchquery="searchquery"/>
          <load-search-query :tableType="tableSearchQueryType" @set-state-6="loadSelectedSearchquery" @set-default-state-6="loadDefaultQuery"/>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <b-spinner label="Spinning"></b-spinner>
          <p id="cancel-label">Filters are loading...</p>
        </div>
      </template>
    </b-overlay>
    <dx-toast
      :visible="showToast"
      message="Data has been successfully added to the pool"
      type="success"
    />
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { createMeiliSearchCustomStore } from '@/store/helpers/remoteOperation.js'
  import 'instantsearch.css/themes/algolia-min.css'
  import { instantMeiliSearch } from '@meilisearch/instant-meilisearch'
  import { MEILISEARCH_HOST, MEILISEARCH_API_KEY } from '@/components/recherche/searchengine-meilisearch/meilisearch-client.js'
  import DxTextBox from 'devextreme-vue/text-box'
  import SaveTemplate from '@/components/template/SaveTemplate.vue'
  import LoadTemplate from '@/components/template/LoadTemplate.vue'
  import SaveSearchQuery from '@/components/searchquery/SaveSearchQuery.vue'
  import LoadSearchQuery from '@/components/searchquery/LoadSearchQuery.vue'
  import { exportDataGrid } from 'devextreme/excel_exporter'
  import ExcelJS from 'exceljs'
  import saveAs from 'file-saver'
  import { matchingFieldNames, formattedExportFields } from '@/components/recherche/rechercheSearch/variables.js'
  import FilterBar from '@/components/recherche/rechercheSearch/Filterbar.vue'
  import InfoModal from '@/components/recherche/rechercheSearch/HelpModal.vue'
  import DetailTemplate from '@/components/recherche/rechercheSearch/masterDetail/MasterDetail.vue'
  import { DxToast } from 'devextreme-vue/toast'
  import { mergeDataFunction } from '@/helpers/externalFunctions.js'
  import _ from 'lodash'
  import moment from 'moment'
  import { isAdmin } from '@/helpers/auth.js'
  import {
    DxDataGrid,
    DxScrolling,
    DxColumn,
    DxHeaderFilter,
    DxFilterRow,
    DxFilterPanel,
    DxPaging,
    DxColumnChooser,
    DxColumnChooserSearch,
    DxLookup,
    DxMasterDetail,
    DxToolbar,
    DxItem
  } from 'devextreme-vue/data-grid'

  const dataGridRecherche2 = 'dataGrid'

  export default {
    components: {
      DxDataGrid,
      DxScrolling,
      DxColumn,
      DxHeaderFilter,
      DxFilterRow,
      DxFilterPanel,
      DxPaging,
      DxTextBox,
      DxColumnChooser,
      DxColumnChooserSearch,
      SaveTemplate,
      LoadTemplate,
      DxLookup,
      FilterBar,
      InfoModal,
      DxMasterDetail,
      DetailTemplate,
      DxToast,
      DxToolbar,
      DxItem,
      SaveSearchQuery,
      LoadSearchQuery
    },
    data () {
      return {
        hasError: false,
        errorMessage: '',
        dataGridRecherche2,
        searchInput: '',
        template: {},
        searchquery: {},
        tableType: 5,
        tableSearchQueryType: 6,
        defaultState: null,
        totalFormat: { style: 'currency', currency: 'CHF', useGrouping: true, minimumSignificantDigits: 3 },
        searchClient: instantMeiliSearch(
          MEILISEARCH_HOST,
          MEILISEARCH_API_KEY,
          {
            primaryKey: 'id'
          }
        ),
        availableFields: matchingFieldNames,
        devExpressFilter: false,
        totalDevExpress: 0,
        initTotalCount: 0,
        updatedTotalCount: false,
        dataSource: [],
        pageSize: 50,
        allowedOperations: ['=', '>', '>=', '<', '<='],
        allowedOperationsString: ['=', '<>'],
        pageIndex: 0,
        searchParam: '',
        modalShow: false,
        isActive: true,
        activateSaveList: true,
        showToast: false,
        defaultVisible: false,
        showOverlay: false,
        loadedValues: 0,
        currentDate: new Date(),
        enableExport: false,
        showTooltip1: false
      }
    },
    created () {
      this.showOverlay = true
      this.getBasicValues('basicValues/GET_FACULTY_UNIVERSITY_TYPES', this.facultyUniversityTypes)
      this.getBasicValues('basicValues/GET_UNIVERSITY_TYPES', this.universityTypes)
      this.getBasicValues('basicValues/GET_BRANCHE_TYPES', this.brancheTypes)
      this.getBasicValues('basicValues/GET_RECHTSFORM_TYPES', this.rechtsformTypes)
      this.getBasicValues('basicValues/GET_COUNTRY_TYPES', this.countryTypes)
      this.getBasicValues('basicValues/GET_SALUTATION_TYPES', this.salutationTypes)
      this.getBasicValues('basicValues/GET_LANGUAGES_TYPES', this.languagesTypes)
      this.getBasicValues('basicValues/GET_EDUCATION_TYPES', this.educationTypes)
      this.getBasicValues('basicValues/GET_CANTON_TYPES', this.cantonTypes)
      this.getBasicValues('basicValues/GET_STARTUPHASE_TYPES', this.startupPhaseTypes)
      this.getBasicValues('basicValues/GET_PRIOVLAB_TYPES', this.priovlabTypes)
      this.getBasicValues('basicValues/GET_PRIOVLABXMAS_TYPES', this.priovlabxmasTypes)
      this.getBasicValues('basicValues/GET_VKCASESTATUS_TYPES', this.vkCaseStatusTypes)
      this.getBasicValues('basicValues/GET_SECTORS', this.sectors)
      this.getBasicValues('basicValues/GET_AWARDS', this.awards)
      this.getBasicValues('basicValues/GET_ROLES', this.roles)
      this.$store.commit('recherche/SET_SEARCHPARAM_MS', '')
      this.$Progress.start()
      this.initStore()
    },
    mounted () {
      this.$refs.filterbarComponent.resetFilter()
      this.defaultState = JSON.stringify(this.dataGrid.state())
    },
    methods: {
      contentReady (e) {
        this.totalDevExpress = this.dataGrid.totalCount()
        if (this.initTotalCount === 0) {
          this.initTotalCount = this.dataGrid.totalCount()
        }
        if (!this.updatedTotalCount) {
          this.$store.commit('recherche/SET_TOTALCOUNT_MS', this.totalDevExpress)
          this.updatedTotalCount = true
        }
        // exporting is only enabled if resuts are less than 10'000, because otherwise it crashes...
        // const excelExporter = document.getElementsByClassName('dx-datagrid-export-button')
        if (this.totalDevExpress <= 15000) {
          this.enableExport = true
          this.activateSaveList = false
        } else if (this.totalDevExpress <= 25000) {
          this.activateSaveList = false
          this.enableExport = false
        } else {
          this.enableExport = false
          // excelExporter[0].classList.add('disable-exporting')
          this.activateSaveList = true
        }
      },
      sendFilters () {
        this.dataGrid.refresh()
      },
      search () {
        this.$store.commit('recherche/SET_SEARCHPARAM_MS', this.searchParam)
        this.dataGrid.refresh()
      },
      initStore () {
        const key = ['id']
        this.dataSource = createMeiliSearchCustomStore({ key })
        this.$Progress.finish()
      },
      getMatchingColumns (rowData) {
        const matchingDatas = this.findAllByTag(rowData._formatted)
        const replacedList = this.replaceKeynames(matchingDatas)
        const uniqArr = _.uniq(replacedList)
        return this.replaceKeynames(uniqArr).join(', ')
      },
      replaceKeynames (arr) {
        const propertyList = arr
        for (var el in propertyList) {
          if (this.availableFields[propertyList[el]]) {
            propertyList[el] = this.availableFields[propertyList[el]]
          }
        }
        return propertyList
      },
      findAllByTag (obj) {
        const self = this
        return Object.entries(obj)
          .reduce((acc, [key, value]) => (value !== undefined && value !== null && typeof value === 'string' && value.includes('<em>'))
                    ? acc.concat(key)
                    : (value !== undefined && value !== null && typeof value === 'object')
                      ? acc.concat(self.findAllByTag(value))
                      : acc
                  , [])
      },
      loadDefaultTemplate () {
        const state = JSON.parse(this.defaultState)
        this.dataGrid.state(state)
      },
      loadDefaultQuery () {
        const state = JSON.parse(this.defaultState)
        this.dataGrid.state(state)
        this.searchParam = ''
        this.$store.commit('recherche/SET_SEARCHPARAM_MS', this.searchParam)
        this.$refs.filterbarComponent.resetFilter()
      },
      loadSelectedTemplate (state) {
        state = JSON.parse(state)
        this.dataGrid.state(state)
      },
      loadSelectedSearchquery (state) {
        this.dataGrid.state(state.tablestate)
        this.searchParam = state.fulltextsearch
        this.$refs.filterbarComponent.setLoadedFilter(state.allSelectedFilters)
        this.search()
      },
      loadState () {
        this.$store.commit('template/SET_LOAD_TEMPLATE_STATUS', true)
      },
      saveState () {
        this.template = {
          state: JSON.stringify(this.dataGrid.state()),
          table_type: this.tableType,
          creator: this.currentUser.mitarbeiterId
        }
        this.$store.commit('template/SET_SAVE_TEMPLATE_STATUS', true)
      },
      saveQuery () {
        const objectState = {
          fulltextsearch: this.searchParam,
          allSelectedFilters: this.saveQueryAllFilters,
          tablestate: this.dataGrid.state()
        }
        this.searchquery = {
          state: JSON.stringify(objectState),
          table_type: this.tableSearchQueryType,
          creator: this.currentUser.mitarbeiterId
        }
        this.$store.commit('template/SET_SAVE_QUERY_STATUS', true)
      },
      loadQuery () {
        this.$store.commit('template/SET_LOAD_QUERY_STATUS', true)
      },
      onExporting () {
        const workbook = new ExcelJS.Workbook()
        const worksheet = workbook.addWorksheet('Recherche_SearchDx')

        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          autoFilterEnabled: true,
          customizeCell: ({ gridCell, excelCell }) => {
            if (gridCell.rowType === 'data') {
              if (formattedExportFields.includes(gridCell.column.dataField)) {
                excelCell.value = (gridCell.value) !== null && (gridCell.value) !== undefined ? (gridCell.value).toString().replaceAll('<em>', '').replaceAll('</em>', '') : null
              }
            }
          }
        }).then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${moment(this.currentDate).format('DD.MM.YYYY')}-Address_Search.xlsx`)
          })
        })
        this.dataGrid.cancel = true
      },
      togglePopOver () {
        this.defaultVisible = !this.defaultVisible
      },
      async getBasicValues (storePath, storeValue) {
        if (storeValue.length === 0) {
          try {
            const { errors } = await this.$store.dispatch(storePath)
            if (errors) throw errors
            this.loadedValues += 1
          } catch (err) {
            this.hasError = true
            this.errorMessage = this.$t('formError.unknownwError')
            setTimeout(() => {
              this.hasError = false
            }, 5000)
          }
        } else {
          this.loadedValues += 1
        }
      },
      tempDevCompany (rowData) {
        return rowData._formatted.company ? rowData._formatted.company.replaceAll('(DEV)', '') : rowData._formatted.company
      },
      calculateSectors (rowData) {
        const listOfSectors = []
        if (rowData.sectors.length) {
          for (const x of rowData.sectors) {
            const obj = this.sectors.find(o => o.field_001 === x)
            if (obj) {
              listOfSectors.push(obj.kategorieDE)
            }
          }
        }
        return listOfSectors.join(', ')
      },
      calculateAwards (rowData) {
        const listOfAwards = []
        if (rowData.contests.length) {
          for (const x of rowData.contests) {
            const obj = this.awards.find(o => o.field_001 === x)
            if (obj) {
              listOfAwards.push(obj.contest_release)
            }
          }
        }
        return listOfAwards.join(', ')
      },
      calculateRoles (rowData) {
        const listOfRoles = []
        if (rowData.roles.length) {
          for (const x of rowData.roles) {
            const obj = this.roles.find(o => o.field_001 === x)
            if (obj) {
              listOfRoles.push(obj.rolle)
            }
          }
        }
        return listOfRoles.join(', ')
      },
      calculateOneLiner (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'oneLiner_en')
      },
      calculateDescription (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'description_open_en')
      },
      calculateEmployees (rowData) {
        return this.selectCorrectProfile(rowData.crmProfiles, 'totalEmployee')
      },
      calculateFemaleFounders (rowData) {
        return this.selectCorrectProfile(rowData.crmProfiles, 'peopleFemaleFounders')
      },
      calculateMaleFounders (rowData) {
        return this.selectCorrectProfile(rowData.crmProfiles, 'peopleMaleFounders')
      },
      calculateOpportunity (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'vleadersproblemopportunity')
      },
      calculateProductservice (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'vleadersProductservice')
      },
      calculateTechnology (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'vleadersTechnologie')
      },
      calculateTargetcustomers (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'vleadersTargetcustomers')
      },
      calculateMarketCompetition (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'vleadersMarketcompetition')
      },
      calculateVleadersTeam (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'vleadersTeam')
      },
      calculateAchievements (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'vLeadersAchievements')
      },
      calculateFinancials (rowData) {
        return this.selectCorrectProfile(rowData._formatted.crmProfiles, 'vleadersFinancials')
      },
      selectCorrectProfile (profiles, column) {
        let columnField = null
        if (profiles.length) {
          const businessProfile = profiles.find(el => el.profiltypId === '2' || el.profiltypId === 2)
          const privateProfile = profiles.find(el => el.profiltypId === '1' || el.profiltypId === 1)

          if (businessProfile) {
            columnField = businessProfile[column]
          } else if (!businessProfile && privateProfile) {
            columnField = privateProfile[column]
          } else {
            columnField = null
          }
        }
        return columnField
      },
      getDisplayExpr (item) {
        return item.geschlecht_PopupExtension ? `${item.ansprechzeile} ${item.geschlecht_PopupExtension}` : `${item.ansprechzeile}`
      },
      toggleSidebar () {
        if (this.isActive) {
          this.isActive = false
        } else {
          this.isActive = true
        }
      },
      addToPool () {
        this.$store.commit('recherche/SET_SAVE_LIST_MAX_LIMIT', this.totalDevExpress)
        this.dataGrid.refresh()
      },
      goToPool () {
        this.$Progress.start()
        this.$router.push({
          name: 'address-pool'
        })
      },
      openColumnChooser () {
        this.dataGrid.showColumnChooser()
      },
      checkAdmin (id) {
        return isAdmin(id)
      }
    },
    watch: {
      lastAddedPoolData: async function (newList, oldList) {
        if (newList.length > 0) {
          this.showToast = true
          const currentPool = this.poolData
          const addedPoolData = this.lastAddedPoolData
          // const mergedPoolData = _.unionBy(addedPoolData, currentPool, 'id')
          const mergedPoolData = await mergeDataFunction(currentPool, addedPoolData, 'search')
          this.$store.commit('recherche/SET_POOL_LIST', mergedPoolData)
          setTimeout(() => {
            this.showToast = false
          }, 4000)
        }
      },
      loadedValues (newValue, oldValue) {
        if (newValue === 16) {
          this.showOverlay = false
        }
      }
    },
    computed: {
      ...mapGetters({
        facultyUniversityTypes: 'basicValues/FACULTY_UNIVERSITY_TYPES',
        universityTypes: 'basicValues/UNIVERSITY_TYPES',
        brancheTypes: 'basicValues/BRANCHE_TYPES',
        countryTypes: 'basicValues/COUNTRY_TYPES',
        rechtsformTypes: 'basicValues/RECHTSFORM_TYPES',
        languagesTypes: 'basicValues/LANGUAGES_TYPES',
        educationTypes: 'basicValues/EDUCATION_TYPES',
        cantonTypes: 'basicValues/CANTON_TYPES',
        salutationTypes: 'basicValues/SALUTATION_TYPES',
        priovlabTypes: 'basicValues/PRIOVLAB_TYPES',
        priovlabxmasTypes: 'basicValues/PRIOVLABXMAS_TYPES',
        vkCaseStatusTypes: 'basicValues/VKCASESTATUS_TYPES',
        startupPhaseTypes: 'basicValues/STARTUPHASE_TYPES',
        sectors: 'basicValues/SECTORS',
        awards: 'basicValues/AWARDS',
        roles: 'basicValues/ROLES',
        poolData: 'recherche/POOL_DATA',
        lastAddedPoolData: 'recherche/LAST_ADDED_POOLDATA',
        saveQueryAllFilters: 'recherche/SAVE_QUERY_ALL_FILTERS'
      }),
      ...mapState({
        currentUser: state => state.user.currentUser
      }),
      dataGrid: function () {
        return this.$refs[dataGridRecherche2].instance
      }
    }
  }
</script>

<style lang="scss">
#gridContainerMeilisearch {
    height: 78vh;
    margin-bottom: 0;
}

.recherche-list .ais-InstantSearch {
  max-width: 100%;
  overflow: hidden;
  margin: 0;
}

.searchbar {
  width: 400px;
  margin: 0 0 0 auto;

  @include media-breakpoint-down(lg) {
    width: 100% !important;
    padding: 0;
    margin: 1rem 0;
  }
}

.filterbar {
  padding-top: 4.4rem;
}

.search-container {
  padding-left: 1rem;

  @include media-breakpoint-down(md) {
    padding-left: 0;
  }

  .meilisearch-datagrid {
    em {
      font-style: normal;
      background: #e4135973;
      padding: 0px;
    }
  }
}

.fa-question-circle {
  cursor: pointer;
}

.dx-datagrid-export-button {
  &.disable-exporting {
    pointer-events: none;

    .dx-icon-xlsxfile {
      color: lightgray;
    }
  }
}

.dx-toast-content {
  min-width: 300px;
  max-width: 400px;
}
</style>
